<template>
  <div class="container">
    <BLoading :active.sync="isLoading" />
    <div v-if="!isLoading" class="columns">
      <div class="column is-10">
        <h1 class="ls-service-history--header">{{ scheduleName }} Service History</h1>
        <ServiceHistoryItem
          v-for="(event, idx) in orderedEvents"
          :key="event.scheduleevent_id"
          :event="event"
          :is-first="idx === 0"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import _ from 'lodash';
import { SERVICE_HISTORY__GET_SCHEDULE } from '@/store/types';
import { lsRouterHelpers, lsScheduleHelpers } from 'ls-vue-common';
import ServiceHistoryItem from './components/ServiceHistoryItem.vue';

export default {
  name: 'ServiceHistoryView',
  components: {
    ServiceHistoryItem,
  },
  data() {
    return {
      property_id: lsRouterHelpers.getParam(this.$route, 'property_id'),
      schedule_id: lsRouterHelpers.getParam(this.$route, 'schedule_id'),
      isCheckingRouting: true,
    };
  },
  computed: {
    ...mapState(['serviceHistory']),
    isLoading() {
      return this.serviceHistory.loadingStatus.isLoading || this.isCheckingRouting;
    },
    orderedEvents() {
      return _.orderBy(this.serviceHistory.schedule.scheduleevents, 'scheduleevent_id', 'desc');
    },
    scheduleName() {
      return lsScheduleHelpers.getScheduleServiceName({
        schedule: this.serviceHistory.schedule,
      });
    },
  },
  async created() {
    await this[SERVICE_HISTORY__GET_SCHEDULE]({
      property_id: this.property_id,
      schedule_id: this.schedule_id,
    });

    if (_.isEmpty(this.serviceHistory.schedule)) {
      return this.$router.push({
        name: 'services',
      });
    }
    if (this.serviceHistory.schedule.type === 'manualquote') {
      return this.$router.push({
        name: 'quoteDetails',
      });
    }
    if (this.serviceHistory.schedule.type === 'instant_quote') {
      return this.$router.push({
        name: 'instantQuoteDetails',
      });
    }
    this.isCheckingRouting = false;
  },
  methods: {
    ...mapActions([SERVICE_HISTORY__GET_SCHEDULE]),
  },
};
</script>

<style lang="scss" scoped>
.ls-service-history--header {
  padding-bottom: 30px;
}

@media (max-width: $mobile-max-width) {
  .ls-service-history--header {
    padding: 10px 0;
    margin-bottom: 10px;
  }
}
</style>
